import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CampaignCrmKpiTotalModel, RenaultKpiActividadTallerBillingHourModel, RenaultKpiActividadTallerBillingHourTotalModel, RenaultKpiActividadTallerTfaTotalModel, RenaultKpiActividadTallerVisitsModel, RenaultKpiActividadTallerVisitsTotalModel, RenaultKpiExcelBriefingType1DTO, RenaultKpiExcelBriefingType2DTO, RenaultKpiExperienciaClienteBonusCalidadTotalModel, RenaultKpiFilter, RenaultKPIMasterElement, RenaultKpiModel, RenaultKpiTotalModel, RenaultKpiYearDaysRatioDTO } from '../models/renault-kpi-dto';
import { Select2Data } from 'ng-select2-component';
import { RenaultKpiGlobalFilter } from '../models/renault-kpi-filter-model';
import { DistributorParams } from '../models/shared-dto';
import { KpiReportGeneratorModel } from '../models/kpi-report-generator-model';

@Injectable({
  providedIn: 'root'
})

export class KpiService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultKpi/";
  public globalFilters = new BehaviorSubject<RenaultKpiGlobalFilter>(this.initGlobalFilters());
  public reportGenerator = new BehaviorSubject<KpiReportGeneratorModel[]>(this.initReportGenerator());
  public isGeneratingReport = new BehaviorSubject<boolean>(this.initIsGeneratingReport());

  constructor(private http: HttpClient) { }

  //#region Global Filters
  resetGlobalFilters() {
    this.globalFilters.next(this.initGlobalFilters());
  }

  initGlobalFilters(): RenaultKpiGlobalFilter {
    let month = (new Date()).getMonth();
    if (month == 0) {
      month++;
    }
    return {
      DistributorFilters: new DistributorParams(),
      Year: new Date().getFullYear(),
      Month: month,
      Brand: ['1', '2'],
      Payment: '1',
      Activity: '0'
    };
  }

  setGlobalFilters(filters: RenaultKpiGlobalFilter) {
    this.globalFilters.next(filters);
  }

  getGlobalFilters(): Observable<RenaultKpiGlobalFilter> {
    return this.globalFilters.asObservable();
  }
  //#endregion

  //#region Report Generator

  initReportGenerator(): KpiReportGeneratorModel[] {
    return this.getStorageReportGenerator();
  }

  private setStorageReportGenerator(value: KpiReportGeneratorModel[]): void {
    window.localStorage['reportGenerator'] = JSON.stringify(value);    
  }

  private getStorageReportGenerator(): KpiReportGeneratorModel[] {
    if (window.localStorage['reportGenerator'] === undefined ||
      window.localStorage['reportGenerator'] === null ||
      window.localStorage['reportGenerator'] === 'null' ||
      window.localStorage['reportGenerator'] === 'undefined' ||
      window.localStorage['reportGenerator'] === '') {
      return [];
    }
    let obj = JSON.parse(window.localStorage['reportGenerator']);       
    return obj;
  }

  setReportGenerator(reportGenerator: KpiReportGeneratorModel[]) {
    this.setStorageReportGenerator(reportGenerator);
    this.reportGenerator.next(reportGenerator);
  }

  getReportGenerator(): Observable<KpiReportGeneratorModel[]> {
    return this.reportGenerator.asObservable();
  }

  initIsGeneratingReport(): boolean {
    return this.getStorageIsGeneratingReport();
  }

  private setStorageIsGeneratingReport(value: boolean): void {
    window.localStorage['isGeneratingReport'] = value;    
  }

  private getStorageIsGeneratingReport(): boolean {
    if (window.localStorage['isGeneratingReport'] === undefined ||
      window.localStorage['isGeneratingReport'] === null ||
      window.localStorage['isGeneratingReport'] === 'null' ||
      window.localStorage['isGeneratingReport'] === 'undefined' ||
      window.localStorage['isGeneratingReport'] === '') {
      return false;
    }
    let obj = window.localStorage['isGeneratingReport'] === 'true';    
    return obj;
  }

  setIsGeneratingReport(isGeneratingReport: boolean) {
    this.setStorageIsGeneratingReport(isGeneratingReport);
    if(!isGeneratingReport) {
      this.setReportGenerator([]);
    }
    this.isGeneratingReport.next(isGeneratingReport);
  }

  getIsGeneratingReport(): Observable<boolean> {
    return this.isGeneratingReport.asObservable();
  }
 
  //#endregion

  downloadExcelUri(): Observable<any> {
    let requestOptions: Object = {
      responseType: 'string'
    }
    let endpoint = this.pathAPI + this.controller + 'GetExcelKpis';
    return this.http.get<any>(endpoint, requestOptions);
  }

  public getKpiData(filters: RenaultKpiFilter): Observable<RenaultKpiTotalModel[]> {
    return this.http.post<RenaultKpiTotalModel[]>(this.pathAPI + this.controller + "GetKpiData", filters);
  }

  public getKpiDataSpecific(idKpis: number[]): Observable<RenaultKpiModel[]> {
    return this.http.post<RenaultKpiModel[]>(this.pathAPI + this.controller + "GetKpiDataSpecific", idKpis);
  }

  public getKpiDataIndividual(idKpi: number, year: number): Observable<RenaultKpiModel[]> {
    return this.http.get<RenaultKpiModel[]>(this.pathAPI + this.controller + "GetKpiDataIndividual/" + idKpi + '/' + year);
  }

  public getKpiDataLastDate(idKpi: number): Observable<Date> {
    return this.http.get<Date>(this.pathAPI + this.controller + "GetKpiDataLastDate/" + idKpi);
  }

  public getKpiActividadTallerVisits(years: number[]): Observable<RenaultKpiActividadTallerVisitsTotalModel[]> {
    return this.http.post<RenaultKpiActividadTallerVisitsTotalModel[]>(this.pathAPI + this.controller + "GetKpiActividadTallerVisits", years);
  }

  public getKpiActividadTallerVisitsByYear(year: number): Observable<RenaultKpiActividadTallerVisitsTotalModel> {
    return this.http.get<RenaultKpiActividadTallerVisitsTotalModel>(this.pathAPI + this.controller + "GetKpiActividadTallerVisitsByYear" + '/' + year);
  }

  public getKpiActividadTallerVisitsLastDate(): Observable<Date> {
    return this.http.get<Date>(this.pathAPI + this.controller + "GetKpiActividadTallerVisitsLastDate");
  }

  public getKpiActividadTallerBillingHour(years: number[]): Observable<RenaultKpiActividadTallerBillingHourTotalModel[]> {
    return this.http.post<RenaultKpiActividadTallerBillingHourTotalModel[]>(this.pathAPI + this.controller + "GetKpiActividadTallerBillingHour", years);
  }

  public GetKpiActividadTallerBillingHourByYear(year: number): Observable<RenaultKpiActividadTallerBillingHourTotalModel> {
    return this.http.get<RenaultKpiActividadTallerBillingHourTotalModel>(this.pathAPI + this.controller + "GetKpiActividadTallerBillingHourByYear" + '/' + year);
  }

  public getKpiActividadTallerBillingHourLastDate(): Observable<Date> {
    return this.http.get<Date>(this.pathAPI + this.controller + "GetKpiActividadTallerBillingHourLastDate");
  }

  public getKpiActividadTallerTfa(years: number[]): Observable<RenaultKpiActividadTallerTfaTotalModel[]> {
    return this.http.post<RenaultKpiActividadTallerTfaTotalModel[]>(this.pathAPI + this.controller + "GetKpiActividadTallerTfa", years);
  }

  public getKpiActividadTallerTfaByYear(year: number): Observable<RenaultKpiActividadTallerTfaTotalModel> {
    return this.http.get<RenaultKpiActividadTallerTfaTotalModel>(this.pathAPI + this.controller + "GetKpiActividadTallerTfaByYear" + '/' + year);
  }

  public getKpiActividadTallerTfaLastDate(): Observable<Date> {
    return this.http.get<Date>(this.pathAPI + this.controller + "GetKpiActividadTallerTfaLastDate");
  }

  public getKpiExperienciaClienteBonusCalidad(years: number[]): Observable<RenaultKpiExperienciaClienteBonusCalidadTotalModel[]> {
    return this.http.post<RenaultKpiExperienciaClienteBonusCalidadTotalModel[]>(this.pathAPI + this.controller + "GetKpiExperienciaClienteBonusCalidad", years);
  }

  public getKpiExperienciaClienteBonusCalidadByYear(year: number): Observable<RenaultKpiExperienciaClienteBonusCalidadTotalModel> {
    return this.http.get<RenaultKpiExperienciaClienteBonusCalidadTotalModel>(this.pathAPI + this.controller + "GetKpiExperienciaClienteBonusCalidadByYear" + '/' + year);
  }

  public getKpiExperienciaClienteBonusCalidadLastDate(): Observable<Date> {
    return this.http.get<Date>(this.pathAPI + this.controller + "GetKpiExperienciaClienteBonusCalidadLastDate");
  }

  public getCampaignCrmKpi(years: number[]): Observable<CampaignCrmKpiTotalModel[]> {
    return this.http.post<CampaignCrmKpiTotalModel[]>(this.pathAPI + this.controller + "GetCampaignCrmKpi", years);
  }

  public getKpiActividadTallerBrand(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetKpiActividadTallerBrand');
  }

  public getKpiActividadTallerPayment(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetKpiActividadTallerPayment');
  }

  public getKpiYearDaysRatio(): Observable<RenaultKpiYearDaysRatioDTO[]> {
    return this.http.get<RenaultKpiYearDaysRatioDTO[]>(this.pathAPI + this.controller + "GetKpiYearDaysRatio");
  }

  public getExcelKpiBriefingType1(data: RenaultKpiExcelBriefingType1DTO): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetExcelKpiBriefingType1';
    return this.http.post<Blob>(endpoint, data, requestOptions);
  }

  public getExcelKpiBriefingType2(data: RenaultKpiExcelBriefingType1DTO): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetExcelKpiBriefingType2';
    return this.http.post<Blob>(endpoint, data, requestOptions);
  }

  public getExcelKpiBriefingType3(data: RenaultKpiExcelBriefingType2DTO): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetExcelKpiBriefingType3';
    return this.http.post<Blob>(endpoint, data, requestOptions);
  }

  public getExcelKpiManagementSummary(data: any[]): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetExcelKpiManagementSummary';
    return this.http.post<Blob>(endpoint, data, requestOptions);
  }

  public getExcelKpiReportGenerator(data: KpiReportGeneratorModel[]): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetExcelKpiReportGenerator';
    return this.http.post<Blob>(endpoint, data, requestOptions);
  }

  public loadAllKpisInCache(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + "LoadAllKpisInCache");
  }

  public getKpiMasterElement(id: number): Observable<RenaultKPIMasterElement> {
    return this.http.get<RenaultKPIMasterElement>(this.pathAPI + this.controller + "GetKpiMasterElement/" + id);
  }

}
